import type { Order } from '../models/Order';

export const adaptOrder = (apiOrder: any): Order => {
  return {
    ...apiOrder,
  };
};
